/** Created by azhou on 2019/3/8.*/
<template>
    <div>
      <public-title >
          {{isGroup?'门店信息':'认证信息'}}
        <span class="text-link ml-auto h6" slot="right" @click="$router.back()" v-if="storeId">返回上一页</span>
      </public-title>
      <div class="load-area">
        <TravelAgency v-if="storeInfo.type==2" ></TravelAgency>
        <!-- <group-store-lists v-else></group-store-lists> -->
        <verify-info  :storeId='storeId' v-else/>
      </div>  
    </div>
</template>

<script>
  import { mapGetters,mapState, mapActions,mapMutations } from 'vuex'
  import { UploadImages } from '@/assets/utils/uploadFiles'
  import VerifyInfo from './Comps/VerifyInfo'
  import VerifyInfoText from './Comps/VerifyInfoText.vue'
  import TravelAgency from './Comps/TravelAgency.vue'
  export default  {
    name: 'Index',
    components: { VerifyInfo,TravelAgency,VerifyInfoText},
    computed: {
      ...mapState(['StoreBasicInfo','newMessageInform']),
      ...mapGetters(['storeInfo','userInfo','isGroup','isAdmin']),
      queryCon() { return this.$route.query },
      storeId() { return this.$route.query.store},
      tabArr() {
        let arr=[]
        if(this.storeInfo.type!==2){
          arr = ['门店信息','高级标签','团队政策','认证信息'];
        }else{
          arr = ['门店信息','认证信息'];
        }
        // if (this.storeInfo.type !== 2) arr.splice(2,0,'酒店信息');
        
        // if (this.storeInfo.type !== 2) arr.splice(2,0,'门店相册');
        if (this.userInfo.type === 99) arr.pop('认证信息');
       return arr;
      }
    },
    data() {
      return {
        activeName:'酒店信息',
        none:0,
      }
    },
    mounted() {
      if (this.$route.query.store) {
        this.UPDATECURRENTSTORE({
          storeId:this.$route.query.store,
          type:Number(this.$route.query.type)
        });
      }
      this.activeName='门店信息';
    },
    destroyed() {
      this.UPDATECURRENTSTORE({storeId:'',type:''})
    },
    watch: {
      newMessageInform (newVal) {
      //更新编辑认证信息
        if(newVal.type==41){
          this.getStoreInfo();      
        }
      }
    },
    methods:{
      ...mapMutations(['UPDATECURRENTSTORE']),
      ...mapActions(['saveStoreInfo','HotelsEditAlbum','getStoreInfo']),
      /*获取门店信息*/
      /*保存用户基础信息*/
      async saveBasicInfo(info) {
        console.log(info);
        let isRegStep = this.userInfo.type !== 99 && this.StoreBasicInfo.verify !== 1;
        if (this.isAdmin && this.activeName === '门店信息') {       //管理员身份设置的用户信息
          info = {
            ...info,
            contract:this.$refs.adminSet.BasicInfo.contract,
            rank:this.$refs.adminSet.BasicInfo.rank,
            person_liable_id:this.$refs.adminSet.BasicInfo.person_liable_id,
            display:this.$refs.adminSet.BasicInfo.display,
          }
        }
        if (this.isAdmin) {
          delete info.contractList;
          delete info.adminList;
          delete info.room_arr;
          delete info.meeting_arr;
          delete info.edit_verify;
        }
        if(this.$refs.adminSet && this.$refs.adminSet.contract_pic){
          info.contract_pic = await UploadImages(this.$refs.adminSet.contract_pic)
        }
        if(info.contract_pic)info.contract_pic=info.contract_pic.join(',');
        //return
        this.saveStoreInfo({
          newInfo: info,
          preservation:1,
          successFun: () => {
            if (isRegStep) {            //单个门店注册页面
              this.getInfo(); 
              switch (this.storeInfo.type) {
                case 2:break;//this.$router.push({ name: 'regVerify' }); 
                case 3:break;
                case 5:
                case 6:
                  this.$router.push({ name: 'regStorePhotos',query:{step:2} }); break;
                default:break;
              }
            } else this.getInfo(); //管理员、单个门店、集团账号修改门店信息
          }
          })
      },
      /*保存用户基础信息*/
      async editAlbum(info) {
        if(this.$refs.adminSet && this.$refs.adminSet.contract_pic){
          info.contract_pic = await UploadImages(this.$refs.adminSet.contract_pic)
        }
        //return
        this.HotelsEditAlbum({
          newInfo: info,
          successFun: () => {          //单个门店注册页面
              this.getInfo();
        }})
      },
    }
  }
</script>
